module.exports = __webpack_public_path__ + "img/time.ef271f97.png";